class CardForm extends HTMLElement {
  constructor() {
    super();

    this.form = this.querySelector("form");
    this.bundleContent = document.querySelector("bundle-content");
    this.form.querySelector("[name=id]") ? (this.form.querySelector("[name=id]").disabled = false) : null;
    this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
    this.submitButton = this.querySelector('[type="submit"]');
  }

  onSubmitHandler(evt) {
    evt.preventDefault();
    const variantId = parseInt(this.form.querySelector("[name=id]").value);
    variantId && this.bundleContent.addProduct(variantId);
  }
}
customElements.define("card-form", CardForm);

class CardVariantRadios extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("change", this.onVariantChange);
    this.productForm = document.getElementById(`bundle-card-product-form-${this.dataset.section}`);
    this.cardContainer = document.getElementById(`card-${this.dataset.section}`);
    this.bundleContent = document.querySelector("bundle-content");
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, false);
    this.updateVariantStatuses();

    if (!this.currentVariant) {
      this.toggleAddButton();
      this.setUnavailable();
    } else {
      this.toggleAddButton(false);
      this.updateVariantInput();
      this.updateVariantPrice();
      this.updateMedia();
    }
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll("fieldset"));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll("input")).find((radio) => radio.checked).value;
    });
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter((variant) => this.querySelector(":checked").value === variant.option1);
    const inputWrappers = [...this.querySelectorAll(".product-form__input")];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
      const previousOptionSelected = inputWrappers[index - 1].querySelector(":checked").value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected)
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
        input.classList.remove("disabled");
      } else {
        input.classList.add("disabled");
      }
    });
  }

  updateVariantInput() {
    const input = this.productForm.querySelector('input[name="id"]');
    input.value = this.currentVariant.id;
    input.dispatchEvent(new Event("change", { bubbles: true }));
  }

  toggleAddButton(disable = true, modifyClass = true) {
    if (!this.productForm) return;
    const addButton = this.productForm.querySelector('[name="add"]');
    if (!addButton) return;

    if (disable || !this.currentVariant.available) {
      addButton.setAttribute("disabled", "disabled");
    } else {
      addButton.removeAttribute("disabled");
    }

    if (!modifyClass) return;
  }

  updateVariantPrice() {
    const price = this.cardContainer.querySelector(".price");
    if (!price) return;
    price.innerHTML = `$${this.currentVariant.price/100}`
  }

  updateMedia() {
    this.cardContainer.querySelector(".image_container.is-active")?.classList.remove("is-active");
    this.cardContainer.querySelector(`.image_container[data-variant-id='${this.currentVariant.id}'`)?.classList.add("is-active");
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}
customElements.define("card-variant-radios", CardVariantRadios);

class BundleVariantRadios extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("change", this.onVariantChange);
    this.productForm = document.getElementById(`product-form-${this.dataset.section}`);
    this.bundleContent = document.querySelector("bundle-content");
    this.cardVariantInputs = document.querySelectorAll("card-variant-radios fieldset.hidden input");
    this.updateOptions();
    this.updateMasterId();
    this.updateCardOptions();
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, "", false);
    this.updateVariantStatuses();
    this.updateCardOptions();
    this.updateBundleItems();
    this.getBundleSize();
    this.updateMedia();
    if (!this.currentVariant) {
      this.toggleAddButton(true, "");
      this.setUnavailable();
    } else {
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
    }
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll("fieldset"));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll("input")).find((radio) => radio.checked).value;
    });
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;

    fetch(`${this.dataset.url}?variant=${requestedVariantId}&section_id=${sectionId}`)
      .then((response) => response.text())
      .then((responseText) => {
        if (this.currentVariant?.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, "text/html");

        const addButtonUpdated = html.getElementById(`ProductSubmitButton-${sectionId}`);
        this.toggleAddButton(addButtonUpdated ? false : true);

        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId,
            html,
            variant: this.currentVariant,
          },
        });
      });
  }

  updateCardOptions() {
    this.cardVariantInputs.forEach((input) => {
      this.options.forEach((option) => {
        input.value == option ? (input.checked = true) : null;
        input.dispatchEvent(new Event("change", { bubbles: true }));
      });
    });
  }

  updateBundleItems() {
    this.bundleContent.replaceItemsSize(this.options[parseInt(this.dataset.bottleSizePosition)]);
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter((variant) => this.querySelector(":checked").value === variant.option1);
    const inputWrappers = [...this.querySelectorAll(".product-form__input")];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
      const previousOptionSelected = inputWrappers[index - 1].querySelector(":checked").value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected)
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
        if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
            input.classList.remove("disabled");
            input.removeAttribute("disabled");
        } else {
            input.classList.add("disabled");
            input.setAttribute("disabled", 'true');
        }
    });
  }

  updateMedia() {
    if (!this.options) return;
    this.bundleContent.querySelectorAll(".placeholder.is-active").forEach((img) => {
      img.classList.remove("is-active");
      img.parentNode.classList.remove("is-active");
    });
    this.options.forEach((option) => {
      this.bundleContent.querySelectorAll(`.placeholder[alt='${option}'`).forEach((img) => {
        if (parseInt(img.closest(".selected_variant")?.dataset.index) < this.bundleSize) {
          img.classList.add("is-active");
          img.parentNode.classList.add("is-active");
        }
      });
    });
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === "false") return;
    window.history.replaceState({}, "", `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const input = this.productForm.querySelector('input[name="id"]');
    input.value = this.currentVariant.id;
    input.dispatchEvent(new Event("change", { bubbles: true }));
  }

  toggleAddButton(disable = true, text, modifyClass = true, preventStateChange = false) {
    if (!this.productForm) return;
    const addButton = this.productForm.querySelector('[name="add"]');
    const addButtonText = addButton.querySelector(".complete_label > span");
    const price = addButton.querySelector(`#price-${this.dataset.section}`);
    if (!addButton) return;

    if (disable || !this.currentVariant) {
      addButton.setAttribute("disabled", "disabled");
      if (text) addButtonText.textContent = text;
    } else {
      if (this.bundleContent.activeItems.length < this.bundleSize) {
        addButton.setAttribute("disabled", "");
        addButton.setAttribute("incomplete", "");
        addButton.querySelector(".incomplete_label [data-pack-size]").innerHTML = this.bundleSize - this.bundleContent.activeItems.length;
      } else {
        if (!preventStateChange) addButton.removeAttribute("disabled");
        addButton.removeAttribute("incomplete");
        addButtonText.textContent = window.variantStrings.addToCart;
        if (price) price.classList.remove("hidden");
      }
    }

    if (!modifyClass) return;
  }

  updateAddButtonIncompleteText() {
    if (!this.productForm) return;
    const addButton = this.productForm.querySelector('[name="add"]');
    const addButtonText = addButton.querySelector(".incomplete_label [data-pack-size]");
    if (!addButton || !addButtonText) return;
    addButtonText.textContent = this.bundleSize - this.bundleContent.activeItems.length;
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }

  getBundleSize() {
    if (!this.options) return;
    this.options.forEach((option) => {
      if (option.includes("Pack")) {
        this.bundleSize = parseInt(option.replace(" Pack", ""));
      }
    });
    return this.bundleSize;
  }

  setUnavailable() {
    const addButton = this.productForm.querySelector('[name="add"]');
    const addButtonText = this.productForm.querySelector('[name="add"] .complete_label > span');
    const price = document.getElementById(`price-${this.dataset.section}`);

    if (!addButton) return;
    addButton.removeAttribute("incomplete");
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add("hidden");
  }
}
customElements.define("bundle-variant-radios", BundleVariantRadios);

class BundleContent extends HTMLElement {
  constructor() {
    super();
    this.activeItems = [];
    this.itemsMap = [];
    this.bundleVariantRadios = document.querySelector("bundle-variant-radios");
    this.bundleProductForm = document.querySelector(".main-bundle bundle-product-form");
    this.customPropertiesContainer = this.bundleProductForm.querySelector(".custom_properties__container");
    this.mobileStickyItemsContainer = this.bundleProductForm.querySelector(".bundle_content");
  }

  initRemoveButtons() {
    this.removeButtons = document.querySelectorAll("button.remove-product");
    this.removeButtons.forEach((button) => {
      button.onclick = this.onRemoveHandler.bind(this);
    });
  }

  onRemoveHandler(e) {
    const variantId = parseInt(e.target.closest(".selected_variant")?.dataset.variant);
    this.removeProduct(variantId);
  }

  addProduct(variantId) {
    if (!variantId) return;

    if (this.activeItems.length < this.bundleVariantRadios.getBundleSize()) {
      this.activeItems.push(variantId);
      this.renderBundleSlots();
    } else {
      console.log("Bundle already full");
      return;
    }
  }

  removeProduct(variantId) {
    if (!variantId) return;
    if (this.activeItems.includes(variantId)) {
      this.activeItems.splice(this.activeItems.indexOf(variantId), 1);
      this.renderBundleSlots();
    }
  }

  replaceItemsSize(currentSize) {
    var newActiveItems = [];
    this.activeItems.forEach((item) => {
      const itemData = this.getVariantData(item);
      const newVariant = itemData.product.variants.find((variant) => {
        return !variant.options
          .map((option, index) => {
            let optionMatch;
            if (index == parseInt(this.dataset.bottleSizePosition)) {
              optionMatch = currentSize === option;
            } else {
              optionMatch = itemData.variant.options[index] === option;
            }
            return optionMatch && variant.available;
          })
          .includes(false);
      });
      if (newVariant) {
        newActiveItems.push(newVariant.id);
      }
    });
    this.activeItems = newActiveItems;
    this.renderBundleSlots(true);
    if (newActiveItems.length === this.activeItems.length) {
    }
  }

  clearSlots() {
    this.querySelectorAll(".selected_variant[data-variant]").forEach((slot) => {
      slot.dataset.variant = "";
      slot.style.backgroundImage = "";
    });
  }

  renderBundleSlots(preventButtonUpdate = false) {
    this.clearSlots();
    this.activeItems.forEach((item, index) => {
      const slot = this.querySelector(`.selected_variant[data-index='${index}']`);
      if (!slot) return;
      const variant = this.getVariantData(item).variant;
      slot.dataset.variant = item;
      slot.style.backgroundImage = `url('${variant.featured_image.src}&width=500')`;
    });
    this.updateBundleContentInputs();
    this.updateBundlePrice();
    if (!preventButtonUpdate) this.bundleVariantRadios.toggleAddButton(false);
  }

  findProduct(variantId) {
    if (!variantId) return;

    const parentProduct = this.getProductsData().find((product) => {
      return product.variants
        .map((variant) => {
          return variantId === variant.id;
        })
        .includes(true);
    });
    return parentProduct;
  }

  getVariantData(variantId) {
    if (!variantId) return;

    const product = this.findProduct(variantId);
    if (!product) return;

    const variant = product.variants.find((variant) => variant.id === variantId);
    return { variant, product };
  }

  updateBundlePrice() {
    let total = 0;
    const bundleItems = this.activeItems.slice(0, this.bundleVariantRadios.getBundleSize());
    bundleItems.forEach((item) => {
      total += this.getVariantData(item).variant.price;
    });
    this.bundleProductForm.querySelector("[data-bundle-price]").innerHTML = `$${total/100}`;
  }

  updateBundleContentInputs() {
    const bundleItems = this.activeItems.slice(0, this.bundleVariantRadios.getBundleSize());
    const reduced = bundleItems.reduce((occurrences, item) => {
      occurrences[item] = (occurrences[item] || 0) + 1;
      return occurrences;
    }, {});

    const properties = {
      '__bundle_id': Date.now(),
      'bundle': `Build Your Own ${this.bundleVariantRadios.getBundleSize()} Pack`
    }
    this.itemsMap = Object.keys(reduced).map((item) => {
      return { id: parseInt(item), quantity: reduced[item], properties };
    });

    this.customPropertiesContainer.innerHTML = "";
    this.mobileStickyItemsContainer.innerHTML = "";

    this.itemsMap.forEach((item, index) => {
      const itemData = this.getVariantData(item.id);
      let input = document.createElement("input");
      input.setAttribute("type", "hidden");
      input.classList.add("properties");
      input.setAttribute("name", "properties[__bundleItem][" + item.id + "]");
      input.setAttribute("value", item.quantity);
      this.customPropertiesContainer.appendChild(input);

      input = document.createElement("input");
      input.setAttribute("type", "hidden");
      input.classList.add("properties");
      input.setAttribute("name", "properties[" + (index + 1) + "]");
      input.setAttribute("value", item.quantity + "x " + itemData.variant.options[1] + " " + itemData.product.title);
      this.customPropertiesContainer.appendChild(input);
    });
    
    bundleItems.forEach((item) => {
      const itemData = this.getVariantData(item);
      let container = document.createElement("div");
      container.classList.add('selected_variant');
      container.setAttribute("data-variant", item);
      let button = document.createElement("button");
      button.setAttribute("type", "button");
      button.classList.add('remove-product', 'button-link');
      button.innerHTML = '+';
      container.appendChild(button);
      let title = document.createElement("span");
      title.innerHTML = `${itemData.variant.option2} ${itemData.product.title}`;
      container.appendChild(title);
      this.mobileStickyItemsContainer.appendChild(container);
    });

    this.initRemoveButtons();
  }

  getProductsData() {
    this.productsData = this.productsData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.productsData;
  }
}
customElements.define("bundle-content", BundleContent);

class BundleProductForm extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector("form");
    this.bundleContent = document.querySelector("bundle-content");
    this.form.querySelector("[name=id]") ? (this.form.querySelector("[name=id]").disabled = false) : null;
    this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
    this.cart = document.querySelector("cart-notification") || document.querySelector("cart-drawer");
    this.submitButton = this.querySelector('[type="submit"]');
    if (document.querySelector("cart-drawer") && this.submitButton) this.submitButton.setAttribute("aria-haspopup", "dialog");

    this.hideErrors = this.dataset.hideErrors === "true";
  }

  onSubmitHandler(evt) {
    evt.preventDefault();
    if (this.submitButton.getAttribute("aria-disabled") === "true") return;

    this.handleErrorMessage();

    this.submitButton.setAttribute("aria-disabled", true);
    this.submitButton.classList.add("loading");
    this.querySelector(".loading-overlay__spinner").classList.remove("hidden");

    const config = fetchConfig("javascript");

    let formData = {
      'items': this.bundleContent.itemsMap
    };

    if (this.cart) {
      formData.sections = this.cart.getSectionsToRender().map((section) => section.id);
      formData.sections_url=  window.location.pathname;
      this.cart.setActiveElement(document.activeElement);
    }
    config.body = JSON.stringify(formData);

    fetch(`${routes.cart_add_url}`, config)
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          publish(PUB_SUB_EVENTS.cartError, {
            source: "product-form",
            // productVariantId: formData.get("id"),
            productVariantId: formData.items.map((x) => x.id).join(','),
            errors: response.errors || response.description,
            message: response.message,
          });
          this.handleErrorMessage(response.description);

          const soldOutMessage = this.submitButton.querySelector(".sold-out-message");
          if (!soldOutMessage) return;
          this.submitButton.setAttribute("aria-disabled", true);
          this.submitButton.querySelector("span").classList.add("hidden");
          soldOutMessage.classList.remove("hidden");
          this.error = true;
          return;
        } else if (!this.cart) {
          if (window.routes.path.includes("/checkouts/")) {
            location.reload();
          } else {
            window.location = window.routes.cart_url;
            return;
          }
        }

        if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, { source: "product-form", productVariantId: formData.items.map((x) => x.id).join(',') });
        this.error = false;
        const quickAddModal = this.closest("quick-add-modal");
        if (quickAddModal) {
          document.body.addEventListener(
            "modalClosed",
            () => {
              setTimeout(() => {
                this.cart.renderContents(response);
              });
            },
            { once: true }
          );
          quickAddModal.hide(true);
        } else {
          this.cart.renderContents(response);
        }
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        this.submitButton.classList.remove("loading");
        if (this.cart && this.cart.classList.contains("is-empty")) this.cart.classList.remove("is-empty");
        if (!this.error) this.submitButton.removeAttribute("aria-disabled");
        this.querySelector(".loading-overlay__spinner").classList.add("hidden");
      });
  }
  handleErrorMessage(errorMessage = false) {
    if (this.hideErrors) return;

    this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector(".product-form__error-message-wrapper");
    if (!this.errorMessageWrapper) return;
    this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector(".product-form__error-message");

    this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

    if (errorMessage) {
      this.errorMessage.textContent = errorMessage;
    }
  }
}

customElements.define("bundle-product-form", BundleProductForm);
